export default {
    "search": {
        "emptySearchNotification": "Please enter some search terms to perform a search",
        "alreadyFiltered": "Already selected"
    },

    "breadcrumbs": {
        "emptySearch": "<empty search>",
        "itemRemove": "Remove"
    },

    "didYouMean": {
        "dymonlyBeforeCorrected": "Did you mean: ",
        "dymonlyAfterCorrected": "?",
        "correctBeforeCorrected": "Showing results for: ",
        "correctBeforeOriginal": ". Search instead for: ",
        "correctAfterOriginal": "",
        "smartBeforeOriginal": "Showing results for: ",
        "smartBeforeCorrected": " and ",
        "smartAfterCorrected": ""
    },

    "pageSizeSelector": {
        "pageSizeChoice": "{size, number} per page",
        "defaultPageSize": "Default ({size, number})",
        "defaultPageSizeChoice": "{size, number} per page (default)"
    },

    "pager": {
        "pageNumberTitle": "Page {page, number}",
        "firstPage": "First page",
        "nextPage": "Next page",
        "previousPage": "Previous page",
        "lastPage": "Last page"
    },

    "sortSelector": {
        "sortByTitle": "Sort by: {text}",
        "sortOther": "<Other>"
    },

    "sort": {
        "relevance": "Relevance",
        "date": "Date",
        "filename": "File name",
        "title": "Title"
    },

    "queryIntent": {
        "externalServiceTimeoutError": "This result page is incomplete due to an internal timeout. Please retry later."
    },

    "scopes": {
        "allScopes": "All scopes"
    }
};
